import { CARDSIZE, CardSize, CARDTYPE, CardType, Rating } from './@types';
export { CARDSIZE, CARDTYPE };
export type { CardSize, CardType, Rating };
import { Estimates, ProgramInfo, CardData, IWorkoutCardProps, ISeriesCardProps, TrainerData, ICardsProps, CardSeriesData } from './@types';
export type { Estimates, ProgramInfo, CardData, IWorkoutCardProps, ISeriesCardProps, TrainerData, ICardsProps, CardSeriesData };
import { DefaultImages } from '@ifit/img/out/defaults';

export const isSmallCard = (cardSize: CardSize | undefined): boolean => cardSize ? cardSize === CARDSIZE.SMALL : false;
export const isLargeCard = (cardSize: CardSize | undefined): boolean => cardSize ? cardSize === CARDSIZE.LARGE : false;
export const isSeries = (cardType: CardType | undefined): boolean => cardType ? cardType === CARDTYPE.SERIES : false;
export const isTrainer = (cardType: CardType | undefined): boolean => cardType ? cardType === CARDTYPE.TRAINER : false;
export const hasRating = (rating: Rating | undefined): boolean => Boolean(rating && rating.average);
export const completedDate = (lastCompleted: string | undefined): string | undefined => {
  return lastCompleted ? new Date(lastCompleted).toLocaleDateString() : undefined;
}

export const determineFallbackImg = (workoutType: string | undefined | null, cardType: CardType): string => {
  let fallbackImg: string;
  if (
    workoutType === 'video' ||
    cardType === CARDTYPE.SERIES ||
    cardType === CARDTYPE.TRAINER
  ) {
    fallbackImg = DefaultImages.Hero;
  } else if (workoutType === 'map') {
    fallbackImg = DefaultImages.PreMap3x;
  } else {
    fallbackImg = DefaultImages.CSVWorkoutDetailsBackgroundIntervals3x;
  }

  return fallbackImg;
}
